import { createRouter, createWebHistory } from 'vue-router';
import { jwtDecode } from "jwt-decode";

// الاستيراد المباشر (للسرعة)
import Login from '../views/Login.vue';
import MainLayout from "@/views/MainLayout.vue";

// التحميل الكسول (Lazy Loading) لتحسين أداء التطبيق


const routes = [
    { path: '/', redirect: '/login' },
    { path: '/login', name: 'login', component: Login },

    // --- مجموعة مسارات المدير (Admin) ---
    {
        path: '/admin',
        component: MainLayout,
        meta: { requiresAuth: true, roles: ['ROLE_ADMIN', 'ROLE_SUPERVISOR']},
        children: [
            { path: '', redirect: { name: 'admin-dashboard' } },
            { path: 'dashboard', name: 'admin-dashboard', component: () => import('../views/admin/AdminDashboard.vue'), meta: { roles: ['ROLE_ADMIN', 'ROLE_SUPERVISOR']} },
            { path: 'users', name: 'admin-users', component: () => import('../views/admin/UserManagement.vue') },
            { path: 'prospects', name: 'admin-prospects', component: () => import('../views/admin/ProspectManagement.vue') },
            { path: 'pending-contracts', name: 'admin-pending', component: () => import('../views/admin/PendingContracts.vue') },
            { path: 'active-clients', name: 'admin-active', component: () => import('../views/admin/ActiveClients.vue') , meta: { roles: ['ROLE_ADMIN'] } },
            { path: 'settings', name: 'admin-settings', component: () => import('../views/admin/ApiSettings.vue') , meta: { roles: ['ROLE_ADMIN'] }},
            { path: 'profile', name: 'admin-profile', component: () => import('@/views/admin/ProfileSettings.vue') },
            {path: 'clients/archive', name: 'AdminArchiveClients', component: () => import('@/views/admin/ArchiveClients.vue'), meta: { title: 'Archives - CAZALEC' }}
        ]
    },
    // --- مجموعة مسارات الموظف (Worker) ---
    {
        path: '/worker',
        component: MainLayout,
        meta: { requiresAuth: true, roles: ['ROLE_WORKER', 'ROLE_SUPERVISOR'] },
        children: [
            { path: '', redirect: { name: 'worker-dashboard' } },
            { path: 'dashboard', name: 'worker-dashboard', component: () => import('@/views/worker/Dashboard.vue') },
            { path: 'workspace', name: 'worker-workspace', component: () => import('@/views/worker/Workspace.vue') },
            { path: 'my-contracts', name: 'worker-contracts', component: () => import('@/views/worker/MyContracts.vue') },
            { path: 'profile', name: 'worker-profile', component: () => import('@/views/worker/Profile.vue') },
            {
                path: 'client/:id',
                name: 'ClientProcessing', // هذا هو الاسم الذي استخدمناه في goToClient
                component: () => import('@/views/worker/Workspace.vue'), // نفس صفحة العمل
                props: true
            }
        ]
    },

    // مسار 404 (اختياري ولكن مهم)
    { path: '/:pathMatch(.*)*', redirect: '/login' }
];

const router = createRouter({
    history: createWebHistory(),
    routes
});

/**
 * حارس المسارات (Navigation Guard)
 * يقوم بفحص التوكن والصلاحيات قبل كل عملية انتقال
 */
router.beforeEach((to, from) => {
    const token = localStorage.getItem('token');

    if (to.matched.some(record => record.meta.requiresAuth)) {
        if (!token) return { name: 'login' };

        try {
            const decoded = jwtDecode(token);
            const userRoles = decoded.roles || [];

            // ✅ نأخذ آخر meta.roles موجودة (الأكثر تخصيصاً تأخذ الأولوية)
            const routeWithRoles = [...to.matched]
                .reverse()
                .find(record => record.meta.roles);
            const requiredRoles = routeWithRoles?.meta.roles;

            if (requiredRoles && requiredRoles.length > 0) {
                const hasAccess = userRoles.some(role => requiredRoles.includes(role));

                if (!hasAccess) {
                    return userRoles.includes('ROLE_WORKER')
                        ? { name: 'worker-dashboard' }
                        : { name: 'login' };
                }
            }

            return true;
        } catch (e) {
            localStorage.clear();
            return { name: 'login' };
        }
    }

    if (to.name === 'login' && token) {
        try {
            const decoded = jwtDecode(token);
            return decoded.roles?.includes('ROLE_ADMIN')
                ? { name: 'admin-dashboard' }
                : { name: 'worker-dashboard' };
        } catch (e) {
            return true;
        }
    }

    return true;
});

export default router;


